import React from 'react'
import PropTypes from 'prop-types'
import { Item } from './.'
import { CurrencyLabel } from 'Shared/CurrencyLabel'

const Balance = ({
  totalizers: { onHold },
  balance: { pointsValue },
  currency
}) => (
  <div className={`col-12 col-md py-2 px-3 ${window.innerWidth < 420 ? 'border-bottom border-color-ui-3' : 'border-right border-color-ui-3'}`}>
    <div className='row'>
      <div className='col-12 mb-1'>
        <h3 className='txt-body color-brand-1 txt-uppercase'>Saldo</h3>
      </div>
      <div className='col-12'>
        <div className='row'>
          <Item description='Disponível'>
            <CurrencyLabel value={pointsValue} {...currency} />
          </Item>
          <Item description='Resgate em Processamento'>
            <CurrencyLabel value={onHold} {...currency} />
          </Item>
          <Item description='Total'>
            <CurrencyLabel value={pointsValue + onHold} {...currency} />
          </Item>
        </div>
      </div>
    </div>
  </div>
)

Balance.propTypes = {
  currency: PropTypes.object.isRequired,
  balance: PropTypes.shape({ pointsValue: PropTypes.number.isRequired })
    .isRequired,
  totalizers: PropTypes.shape({ onHold: PropTypes.number.isRequired })
    .isRequired
}

export default Balance



// WEBPACK FOOTER //
// ./src/Participant/Extract/Totalizers/Balance.js